"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RtcCommand_1 = require("../Engine/Command/RtcCommand");
const SessionDefinition_1 = require("./SessionDefinition");
class SessionCommand {
    static StartNewSessionCommand(senderReceiverSt) {
        const sender = senderReceiverSt.Item1;
        const receiver = senderReceiverSt.Item2;
        const st = senderReceiverSt.Item3;
        return RtcCommand_1.RtcCommand.Builder().AutoId()
            .Category(SessionCommand.Category)
            .Name(SessionCommand.StartNewSession)
            .CmdTypeAction(RtcCommand_1.CmdType.RequestExecute)
            .Sender(sender.name)
            .AddReceiver(receiver.name)
            .TargetId(st.id)
            .Content(senderReceiverSt)
            .Build();
    }
    static StartNewSessionCommandResponseReject(rtcCmd, senderReceiverSt) {
        const sender = senderReceiverSt.Item1;
        return RtcCommand_1.RtcCommand.Builder(rtcCmd)
            .Category(SessionCommand.Category)
            .Name(SessionCommand.StartNewSession)
            .CmdTypeAction(RtcCommand_1.CmdType.ResponseReject)
            .Sender(sender.name)
            .ClearReceiver()
            .AddReceiver(rtcCmd.sender)
            .Content(senderReceiverSt)
            .Build();
    }
    static StartNewSessionCommandRequestCancel(orgRtcCmd) {
        return RtcCommand_1.RtcCommand.Builder(orgRtcCmd)
            .CmdTypeAction(RtcCommand_1.CmdType.RequestCancel)
            .Build();
    }
}
SessionCommand.Category = SessionDefinition_1.SessionCommandCategory;
SessionCommand.StartNewSession = "StartNewSession";
SessionCommand.JoinExistSession = "JoinExistSession";
exports.SessionCommand = SessionCommand;
//# sourceMappingURL=SessionCommand.js.map